import {isEmpty} from "@helpers/helpers";

export function handleFixedButtonShowAndHide(cardRefOffsetTop, fixButtonRef) {

    if (!isEmpty(fixButtonRef.current)) {
        const windowHeight = window.innerHeight;
        const offsetTop = window.pageYOffset;

        if (!isEmpty(fixButtonRef.current)) {
            if ((cardRefOffsetTop + 300) > offsetTop) {
                if ((cardRefOffsetTop - windowHeight + 100) < offsetTop) {
                    fixButtonRef.current.classList.remove('d-block');
                    fixButtonRef.current.classList.add('d-none');
                } else {
                    fixButtonRef.current.classList.remove('d-none');
                    fixButtonRef.current.classList.add('d-block');
                }
            } else {
                fixButtonRef.current.classList.remove('d-none');
                fixButtonRef.current.classList.add('d-block');
            }
        }
    }
}
